import { DateTime } from "luxon";
import { getSessionStorage } from "./getSessionStorage";

const sessionStorage = getSessionStorage();

// Base session storage module
export function SessionStorage(
  key: string,
  type?: "string",
): {
  set: (value: string | null | undefined) => void;
  get: () => string | null;
  remove: () => void;
};
export function SessionStorage(
  key: string,
  type: "DateTime",
): {
  set: (value: DateTime | null | undefined) => void;
  get: () => DateTime | null;
  remove: () => void;
};
export function SessionStorage(key: string, type: "string" | "DateTime" = "string") {
  const set = (value: string | null | undefined) => {
    if (!value) {
      sessionStorage.removeItem(key);
    } else {
      sessionStorage.setItem(key, value);
    }
  };

  /**
   * Serialize a Luxon DateTime object and record in sessionStorage. Shoule be retrieved with `getDateTime`.
   */
  const setDateTime = (dateTime: DateTime | null) => {
    if (dateTime && !dateTime.isValid) {
      throw new Error(
        "The DateTime provided is not valid! No sessionStorage set will be performed.",
      );
    }
    set(dateTime?.toISO());
  };

  const get = () => sessionStorage.getItem(key);

  const getDateTime = () => {
    const maybeDateTime = get();
    if (maybeDateTime) {
      const time = DateTime.fromISO(maybeDateTime);
      if (!time.isValid && time.invalidExplanation) {
        throw new Error(`DateTime could not be parsed: ${time.invalidExplanation}`);
      }
      return time;
    }
    return null;
  };

  const remove = () => sessionStorage.removeItem(key);

  switch (type) {
    case "string":
      return { set, get, remove };
    case "DateTime":
      return { set: setDateTime, get: getDateTime, remove };
  }
}

const LAST_TAB_FOCUS_TIMESTAMP = "LastTabFocus";
export const lastTabFocusTimestamp = SessionStorage(LAST_TAB_FOCUS_TIMESTAMP, "DateTime");

const LAST_CHROME_WRAPPER_MOUNT_TIMESTAMP = "LastChromeWrapperMount";
export const lastChromeWrapperMountTimestamp = SessionStorage(
  LAST_CHROME_WRAPPER_MOUNT_TIMESTAMP,
  "DateTime",
);

const LAST_ACTIVE_INTERACTION_TIMESTAMP = "LastActiveInteraction";
export const lastActiveInteractionTimestamp = SessionStorage(
  LAST_ACTIVE_INTERACTION_TIMESTAMP,
  "DateTime",
);

const LAST_FEATURE_GRID_REFETCH = "LastFeatureGridRefetch";
export const lastFeatureGridRefetchTimestamp = SessionStorage(
  LAST_FEATURE_GRID_REFETCH,
  "DateTime",
);
